export enum AccountValidationStatus {
  VALIDATION_IN_PROGRESS = "VALIDATION_IN_PROGRESS",
  VALIDATED = "VALIDATED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
}

export interface IBankAccountInfo {
  clabe: string;
  status: AccountValidationStatus;
  reason?: string;
  recentValidatedClabe?: string;
}
